/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useState, useRef, useEffect } from 'react';
import Model from '@tripian/model';
import CategoryList from '../CategoryList/CategoryList';
import { Filter } from '../base/Svg/Icons';
import classes from './PoiCategories.scss';

interface PoiCategoriesProps {
  categoryGroups: Model.PoiCategoryGroup[];
  selectedCategoryIds: number[];
  onCategoryChange?: (selected: Model.PoiCategory[]) => void;
  t: (value: Model.TranslationKey) => string;
}

const PoiCategories: React.FC<PoiCategoriesProps> = ({ categoryGroups, selectedCategoryIds, onCategoryChange, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleCategoryChange = (selected: Model.PoiCategory[]) => {
    onCategoryChange?.(selected);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={classes.poiCategories} ref={wrapperRef}>
      <button type="button" className={classes.poiCategoriesButton} onClick={() => setIsOpen((prev) => !prev)}>
        <div className={classes.poiCategoriesButtonContent}>
          <Filter className="mr2" fill="#000" />
          {selectedCategoryIds.length === 0 ? (
            <span className={classes.poiCategoriesButtonPlaceholder}>{t('trips.myTrips.exploreMore.selectCategory')}</span>
          ) : (
            <div className={classes.poiCategoriesButtonContentText}>
              {(() => {
                const selectedNames: string[] = categoryGroups
                  .flatMap((group: Model.PoiCategoryGroup) => group.categories)
                  .filter((cat: Model.PoiCategory) => selectedCategoryIds.includes(cat.id))
                  .map((cat: Model.PoiCategory) => cat.name);

                const displayCount = 1;
                const remaining: number = selectedNames.length - displayCount;

                return (
                  <span className={classes.poiCategoriesButtonText}>
                    {selectedNames[0] || ''}
                    {remaining > 0 && `, +${remaining}`}
                  </span>
                );
              })()}
            </div>
          )}
        </div>
        <div className={classes.poiCategoriesButtonIndicator}>
          <span className={classes.poiCategoriesButtonSeparator} />
          <div className={classes.poiCategoriesButtonIcon}>
            <svg className={classes.poiCategoriesButtonIconSvg} height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
            </svg>
          </div>
        </div>
      </button>

      {isOpen && (
        <div className={classes.poiCategoriesDropdown}>
          <CategoryList categories={categoryGroups} selectedCategoryIds={selectedCategoryIds} onChange={handleCategoryChange} />
        </div>
      )}
    </div>
  );
};

export default PoiCategories;
